export enum VIEW_MODES {
  FULLREPORT,
  QUICKREPORT,
  SUMMARY,
  HOLIDAYS,
}
